<template>
    <div class="modal-goods">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">选择老人</div>
                <el-button type="danger" @click="closeSelf">关闭</el-button>
            </div>
            <div class="modal-body" style="padding:20px">
                <el-row>
                    <el-form :model="searchForm" inline :rules="rules" ref="searchForm">
                        <div>
                            <el-form-item prop="name">
                                <el-input  placeholder="输入姓名" v-model="searchForm.name" clearable style="width:110px;"></el-input>
                            </el-form-item>
                            <el-form-item prop="phone">
                                    <el-input  placeholder="输入手机号" v-model="searchForm.phone" maxlength="11" clearable style="width:150px;"></el-input>
                                </el-form-item>
                            <el-form-item prop="idCard">
                                <el-input  placeholder="输入身份证号" v-model="searchForm.idCard" clearable style="width:220px;"></el-input>
                            </el-form-item>
                            <el-form-item  prop="zoneCode" >
                                <elSelectTree ref="elSelectTree" :options='zoneValue' placeholder="请选择地区" accordion :props="zoneProps"
                                              v-on:getZoneValue="getZoneValue" style="width:200px;"></elSelectTree>
                            </el-form-item>
                            <el-button  type="primary" icon="el-icon-search" @click="getElderly">搜索</el-button>
                        </div>
                    </el-form>
                </el-row>
                <el-row >
                    <el-col :span="24">
                        <el-table
                            :data="elderlyInfo" ref="myTable"
                            style="width: 100%" border :height="th">
                            <el-table-column fixed prop="name" label="姓名" width="100"></el-table-column>
                            <el-table-column prop="idCard" label="身份证号" width="180"></el-table-column>
                            <el-table-column prop="zoneName" label="所属区域"></el-table-column>
                            <el-table-column fixed="right" label="操作" width="210">
                                <template slot-scope="scope">
                                    <el-button type="primary" size="small" @click.native.prevent="handleGetGood(scope.$index, scope.row)">添加服务</el-button>
                                    <el-button type="success" size="small" @click.native.prevent="handleOpenCart(scope.$index, scope.row)">查看购物车</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-col>

                    <div style="text-align: left;background-color: #fff;padding: 10px;">
                        <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/searchForm.pageSize)}}页）</div>
                        <div style="float: left;">
                            <el-pagination
                                    background
                                    layout="prev, pager, next"
                                    :total="totalItems"
                                    :page-size="20"
                                    :current-page.sync="currentPage"  @current-change="current_change">
                            </el-pagination>
                        </div>
                        <div style="clear: both;"></div>
                    </div>

                </el-row>

            </div>
        </div>
        <GetGood ref="myGetGood" v-show="showModalGetGood" v-on:closeGetGood="closeGetGood"></GetGood>
        <Cart ref="myCart" v-show="showModalCart" v-on:closeCart="closeCart" v-on:getList="getList" ></Cart>
    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";
    import elSelectTree from "../../../components/ElSelectTree"
    import GetGood from "./GetGood"
    import Cart from "./Cart"
    import elderly from "@/common/status";


    export default {
        name: 'Add',
        props:['zoneValue'],
        data() {
            return {
                showModalGetGood:false,
                showModalCart:false,
                zoneProps:{
                    emitPath:false,
                    value: 'zoneCode',
                    // 显示的文字字段名
                    label: 'name',
                    // 子层级字段名
                    children: 'listZoneDTO'
                },
                th:this.$store.state.tableHeight-20,
                elderlyTypeValue:[{
                    value:-1,label:'服务类型'
                },
                {
                    value:0,label:'政府购买服务'
                },
                {
                    value:1,label:'有偿服务'
                }],
                elderlyClassValue:[{
                    value:-1,label:'补助类型'
                },
                {
                    value:0,label:'一般助餐补助老人'
                },
                {
                    value:1,label:'70岁以上低保老人'
                },
                {
                    value:2,label:'70岁以上空巢老人(无子女)'
                },
                {
                    value:3,label:'90岁以上高龄老人'
                }],
                loading: false,
                elderlyInfo:[],
                totalItems:0,
                searchForm:{
                    phone:'',
                    idCard:'',
                    zoneCode:'',
                    elderlyType:-1,
                    elderlyClass:-1,
                    pageSize:20,
                    pageIndex:1,
                    name:'',
                    censusRegister:-1
                },
                rules:{
                    idCard:[elderly.rules.idCard[1],elderly.rules.idCard[2]]
                }
            }
        },
        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                console.log(val);
                this.th=val-20
            },
        },
        components:{
            GetGood,Cart,elSelectTree
        },
        methods: {
            init(){
                this.name=''
                this.idCard=''
                this.zoneCode=''
                this.getElderly()
            },
            closeSelf() {
                this.$emit("closeAdd");
                this.$emit("getList");
            },
            current_change:function(currentPage){
                this.searchForm.pageIndex = currentPage;
                this.getElderly();
            },
            handleGetGood(index, row) {
                this.$refs.myGetGood.init(row);
                this.showModalGetGood = !this.showModalGetGood;
            },
            handleOpenCart(index, row) {
                this.$refs.myCart.init(row);
                this.showModalCart = !this.showModalCart;
            },
            closeGetGood:function(){
                this.showModalGetGood = !this.showModalGetGood;
            },
            getZoneValue(val){
                this.searchForm.zoneCode=val
            },
            closeCart:function(){
                this.$emit("closeAdd")
                this.showModalCart = !this.showModalCart;
            },
            getList(isSearch){
              if(isSearch)this.currentPage=1
             this.$emit("getList")
            },

            getElderly(){
                if(!this.searchForm.zoneCode){
                    this.searchForm.zoneCode='00000000-0000-0000-0000-000000000000'
                }
                this.searchForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);
                this.searchForm.timeStr = timeStr
                this.searchForm.staffCode = getStaffCode()
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"Elderly/GetRechargeElderly",
                    data: this.searchForm
                }).then(
                    (response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                            this.elderlyInfo=response.data.data.list;
                            this.totalItems = response.data.data.total;
                            if(this.searchForm.zoneCode=='00000000-0000-0000-0000-000000000000'){
                                this.searchForm.zoneCode=''
                            }

                            this.$nextTick(()=>{
                              this.$refs.myTable.doLayout();
                            })

                        }else if(response.data.error == 1){
                            this.$message.error(response.data.message)
                        }
                    }
                )
            },


        }
    }


</script>





<style lang="scss" scoped>

    .modal-goods {
        position: fixed;
        top: 50px;
        right: 0;
        bottom: 0;
        left: 200px;
        background-color: rgba(0,0,0,.3);
        display: flex;
        z-index: 99;

        .modal {
            background-color: #fff;
            box-shadow:  none;
            border-radius: 0;
            width: 100%;

            .modal-header {
                border-bottom: 1px solid #eee;
                color: #313131;
                justify-content: space-between;
                padding: 10px;
                display: flex;
            }
            .modal-body {
                position: relative;
                padding: 20px 20px 0;
                z-index: 99;
                height: 100%;
                overflow-y: auto;
            }
            .modal-body /deep/ .el-card.is-always-shadow{
                box-shadow:none;
                border-bottom: none;
                margin-bottom: 20px;
            }
            .modal-footer {
                border-top: 1px solid #eee;
                justify-content: center;
                padding: 15px;
                display: flex;
                .el-button{
                    width: 15%;
                }
            }


        }

    }


    .btn-close, .btn-confirm {
        border-radius: 8px;
        margin-left:16px;
        width:56px;
        height: 36px;
        border:none;
        cursor: pointer;
    }
    .btn-close {
        color: #313131;
        background-color:transparent;
    }



    .row{
        padding: 10px 0px;
    }
    .item{
        padding: 0px 20px;
    }
    .label{
        padding: 5px 0px;
    }


</style>
